import { useState } from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Autocomplete,
  TextField,
} from "@mui/material";
import { RectangularTextButton } from "components/Base/Buttons";

interface AddItemButtonProps {
  nodeId: number;
  fieldName: string;
  itemType: "People" | "Addresses";
  itemAPI: { getAll: () => Promise<any[]> };
  nodeAPI: { updateField: (id: number, field: string, value: any) => Promise<any> };
  currentItems: any[];
  onAdded?: () => void;
  automaticallyRemoveFromOtherNodes?: boolean;
}

export default function AddItemButton({
  nodeId,
  fieldName,
  itemType,
  itemAPI,
  nodeAPI,
  currentItems,
  onAdded,
  automaticallyRemoveFromOtherNodes = false,
}: AddItemButtonProps) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [allItem, setAllItem] = useState<any[]>([]);
  const [selectedItem, setSelectedItem] = useState<any[]>([]);

  const openDialog = async () => {
    setDialogOpen(true);

    const list = await itemAPI.getAll();
    setAllItem(list);
  };

  const closeDialog = () => {
    setDialogOpen(false);
    setSelectedItem([]);
  };

  const handleAdd = async () => {
    if (selectedItem.length === 0) return;

    const existingIds = currentItems.map((p) => p.id);
    const newIds = selectedItem.map((p) => p.id);
    const mergedIds = Array.from(new Set([...existingIds, ...newIds]));

    await nodeAPI.updateField(nodeId, fieldName, mergedIds);

    closeDialog();
    onAdded?.();
  };

  return (
    <>
      <RectangularTextButton colour="clear" onClick={openDialog}>
        Add {itemType}
      </RectangularTextButton>

      <Dialog open={dialogOpen} onClose={closeDialog} maxWidth="sm" fullWidth>
        <DialogTitle>Select {itemType} to Add</DialogTitle>

        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <Autocomplete
              multiple
              options={allItem}
              value={selectedItem}
              onChange={(_, value) => setSelectedItem(value)}
              getOptionLabel={(p) =>
                itemType === "People"
                  ? `${p.first_name} ${p.last_name}`
                  : `${p.street_address}, ${p.city}`
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={`Search ${itemType.toLowerCase()}…`}
                />
              )}
            />
          </Box>

          <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
            <RectangularTextButton
              colour="highlighted"
              onClick={handleAdd}
              disabled={selectedItem.length === 0}
            >
              Add Selected {itemType}
            </RectangularTextButton>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}